require('./intersection-observer');

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import Footer from './components/GroupamaFooter'
import EtreAgir from './components/EtreAgir'
import Temoignages from './components/Temoignages'
import RaisonEtre from './components/RaisonEtre'
import Languages from './components/Languages'
import MainNav from './components/Navigation'
import TemoignageBody from './components/TemoignageBody'
import Popin from './components/Popin'

Vue.component('groupama-footer', Footer);
Vue.component('etre-agir', EtreAgir);
Vue.component('temoignages', Temoignages);
Vue.component('raison-etre', RaisonEtre);
Vue.component('languages', Languages);
Vue.component('main-navigation', MainNav);
Vue.component('temoignage-body', TemoignageBody);
Vue.component('popin', Popin);

new Vue({
  router,
  ...App,
}).$mount('#app')
